
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal-disclaimers",
      function () {
        return require("private-next-pages/legal-disclaimers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal-disclaimers"])
      });
    }
  